import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// room bonus 主页  https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=45000407
export const room_bonus_home = createAsyncThunk(
  'room_bonus_home',
  async (arg: {title_offset: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'is_owner'
          | 'is_open'
          | 'list'
          | 'cur_sum'
          | 'desc'
          | 'title_offset'
          | 'left_more'
          | 'right_more'
          | 'title'
          | 'room_threshold'
          | 'room_reward_rate'
          | 'yesterday_desc'
          | 'yesterday_status'
        >
      >
    >(
      '/live/activity/room_bonus_home',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const room_bonus_receive = createAsyncThunk(
  'room_bonus_receive',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<{succes: boolean}>>(
      '/live/activity/room_bonus_receive',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface InitialStateType {
  // false：没有流水主页 true：有流水页面
  is_owner?: boolean
  // false：没有加入工会，true：有加入工会
  is_open?: boolean
  list?: Array<{st_et: string; sum: number; threshold: number; reward: number}>
  cur_sum?: number
  desc?: string
  title_offset?: number
  left_more?: boolean
  right_more?: boolean
  title?: string
  room_threshold?: number
  room_reward_rate?: string
  yesterday_desc?: string
  // 0: 未解锁 1:未领取 2：已领取
  yesterday_status?: 0 | 1 | 2
  // 为防止以后新开区,存在类似的阶段规则.
  // 当该字段为true时,使用stage_ reward_desc, 而不用room_reward_rate
  is_show_stage_reward_desc?: boolean
  stage_reward_desc?: string
}

const initialState: InitialStateType = {}

export const RoomBonusSlice = createSlice({
  name: 'RoomBonus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(room_bonus_home.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(room_bonus_receive.fulfilled, (state, action) => {
      const {succes} = action.payload
      if (succes) {
        Object.assign(state, {yesterday_status: 2})
      }
    })
  },
})
export default RoomBonusSlice.reducer
